(function () {
  'use strict';

  /* @ngdoc object
   * @name alert
   * @description
   *
   */
  angular
    .module('alert', [
      'ui.router'
    ]);
}());
